import { gql } from '@apollo/client'

export const GUEST_COUNT_QUERY = gql`
  query GuestBoardingStatsByDateRange(
    $embarkDateRange: EmbarkDateRangeFilter!
  ) {
    guestBoardingStatsByDateRange(embarkDateRange: $embarkDateRange) {
      onBoarded
      checkedIn
    }
  }
`

export const GUEST_CREW_VISITOR_MOVEMENTS_QUERY = gql`
  query SearchEmbarkationAuditLogs($filter: EmbarkationAuditLogFilter!) {
    searchEmbarkationAuditLogs(filter: $filter) {
      id
      actionType
      applicationId
      changeForEntityKey
      changeForEntityType
      changedByUserId
      changedByUserType
      changedDate
      correlationId
      isDeleted
      entityKey
      entityType
      groupType
      lastModifiedByApplication
      lastModifiedByUser
      lastModifiedDate
      modifiedByUser
      modifiedDateEpoch
      changeSet {
        field
        newValue
        oldValue
        operation
        type
      }
    }
  }
`
export const CHANGE_PERSON_STATUS_MUTATION = gql`
  mutation UpdatePersonEmbarkationStatus(
    $input: UpdatePersonEmbarkationStatusInput!
  ) {
    updatePersonEmbarkationStatus(input: $input) {
      id
    }
  }
`

export const UPDATE_EMBARK_DEBARK_PORT_MUTATION = gql`
  mutation UpdateEmbarkDebarkPort($input: UpdateEmbarkDebarkPortInput!) {
    updateEmbarkDebarkPort(input: $input) {
      reservationGuestIds
    }
  }
`

export const UPDATE_RESERVATION_GUEST_DOCUMENTS_RETURNED_MUTATION = gql`
  mutation UpdateReservationGuestDocumentsReturned(
    $input: AckDocumentCollectedInput!
  ) {
    updateReservationGuestDocumentsReturned(input: $input) {
      id
      success
    }
  }
`

export const SEND_LUGGAGE_TAG_EMAILS_MUTATION = gql`
  mutation SendLuggageTagEmails($input: SendLuggageTagEmailsInput!) {
    sendLuggageTagEmails(input: $input) {
      successCount
      skippedCount
      errorCount
      results {
        reservationGuestId
        status
        message
      }
    }
  }
`

export const GET_STATEROOM_PARTY_QUERY = gql`
  query ReservationGuestsWithPageination(
    $filter: ReservationGuestFilter!
    $searchSocialConnectionsFilter2: SocialConnectionSearchInput!
    $pageFilter: PageFilter!
  ) {
    reservationGuestsWithPageination(filter: $filter) {
      reservationGuests {
        id
        guest {
          personalInfo {
            firstName
            lastName
            securityImageId
          }
        }
        reservation {
          number
        }
      }
    }
    searchSocialConnections(
      filter: $searchSocialConnectionsFilter2
      pageFilter: $pageFilter
    ) {
      socialConnections {
        firstName
        lastName
        guestId
        reservationGuestId
        securityPhotoMediaItemId
        reservationNumber
        stateroom
        isSameStateroom
      }
    }
  }
`

export const GET_GUEST_BOARDING_NUMBER_QUERY = gql`
  query SearchGuestBoardingNumbers($filter: GuestBoardingNumberSearchFilter!) {
    searchGuestBoardingNumbers(filter: $filter) {
      id
      boardingNumber
      selectedBoardingStartTime
      slotNumber
      embarkDate
      reservationGuestId
      reservationId
      shipCode
      guestId
    }
  }
`

export const LIST_STATEROOM_QUERY = gql`
  query SearchStaterooms(
    $filter: SearchStateroomFilter!
    $pageFilter: PageFilter
    $pageSort: PageSort
  ) {
    searchStaterooms(
      filter: $filter
      pageFilter: $pageFilter
      pageSort: $pageSort
    ) {
      pageInfo {
        page
        size
        totalPages
        totalResults
      }
      staterooms {
        number
        category
        categoryCode
        id
        stationLocationCode
        station
        availableCapacity
        additionalAttributeCodes
        capacity
        deckNumber
        isCrew
        isSplCabinServiceCabin
        isVirtual
        occupancy
        reservationNumbers
        shipCode
      }
    }
  }
`
